export default __webpack_public_path__ + "1c2070f576a5f3bee11962cf10a7e1df.png";